import { Center, Link } from '@chakra-ui/react';
import React from 'react';

import Skeleton from 'ui/shared/chakra/Skeleton';
import type { IconName } from 'ui/shared/IconSvg';
import IconSvg from 'ui/shared/IconSvg';

type Props = {
  icon?: IconName;
  iconSize?: string;
  text: string;
  url: string;
  isLoading?: boolean;
  active?: boolean;
};

const FooterLinkItem = ({
  icon,
  iconSize,
  text,
  url,
  isLoading,
  active,
}: Props) => {
  if (isLoading) {
    return <Skeleton my="3px">{ text }</Skeleton>;
  }

  return (
    <Link
      href={ url }
      display="flex"
      alignItems="center"
      h="30px"
      variant="secondary"
      target="_blank"
      fontSize="xs"
      pointerEvents={ active ? 'auto' : 'none' }
      opacity={ active ? 1 : 0.5 }
    >
      { icon && (
        <Center minW={ 6 } mr={ 2 }>
          <IconSvg boxSize={ iconSize || 5 } name={ icon }/>
        </Center>
      ) }
      { text }
    </Link>
  );
};

export default FooterLinkItem;
